module.exports = __webpack_public_path__ + "img/hold.b5e48eac.svg";